import {AxiosResponse} from 'axios';
import {AnyAction} from 'redux';
import {ThunkAction} from 'redux-thunk';

import {commentFetching, commentReceived} from '../../../actions/comments';
import request, {HttpMethod} from '../../../application/api/request';
import selectAlpenroseHost from '../../../entities/pageSetup/apiHosts/selectors/selectAlpenroseHost';
import {State} from '../../../store/initialState';

import {fetchCommentsResponse} from './fetchComments';


export default function fetchRemovedComments(commentId: number): ThunkAction<Promise<void | fetchCommentsResponse>, State, unknown, AnyAction> {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(commentFetching());

    return request<fetchCommentsResponse>(state, {
      url: `${selectAlpenroseHost(state)}/comment/${commentId}`,
      method: HttpMethod.delete,
    })
      .then((response: AxiosResponse<fetchCommentsResponse>) => {
        dispatch(commentReceived(response.data));

        return response.data;
      });
  };
}
